<era-guest-info-ui [guest]="reservation()?.SubReservations[0].PrimaryGuest"
                   [extraData]="room()?.ExtraData"
                   [roomConfiguration]="roomConfiguration()"
                   (extraDataChange)="onExtraDataChange($event)"
                   (roomConfigurationChange)="onRoomConfigurationChange($event)">
</era-guest-info-ui>